document.addEventListener("DOMContentLoaded", function () {
    // Funktion, um URL-Parameter zu extrahieren
    function getURLParameter(name) {
        return new URLSearchParams(window.location.search).get(name);
    }

    // Farben aus der URL holen oder aus dem sessionStorage
    const mainColor = getURLParameter('main-color') || sessionStorage.getItem('main-color') || "#ffffff"; // Standardfarbe: Weiß
    const secondColor = getURLParameter('second-color') || sessionStorage.getItem('second-color') || "#000000"; // Standardfarbe: Schwarz

    // Rabattinformationen aus URL oder sessionStorage holen
    const discount = getURLParameter('promodiscount') || sessionStorage.getItem('discount');
    const code = getURLParameter('code') || sessionStorage.getItem('code');
    const expiryDate = getURLParameter('expiry') || sessionStorage.getItem('expiry');

    // HTML-Elemente, die befüllt oder gestylt werden sollen
    const discountElement = document.getElementById("promotion-discound");
    const codeElement = document.getElementById("promotion-code");
    const expiryDateElement = document.getElementById("promotion-ablauf-date-info");
    const emailHeader = document.querySelector(".email-promotion-header");
    const promoButton = document.querySelector(".email-promotion-header__promotion-button");

    // Wenn Parameter in der URL vorhanden sind, im sessionStorage speichern
    if (getURLParameter('main-color')) sessionStorage.setItem('main-color', mainColor);
    if (getURLParameter('second-color')) sessionStorage.setItem('second-color', secondColor);
    if (getURLParameter('promodiscount')) sessionStorage.setItem('discount', discount);
    if (getURLParameter('code')) sessionStorage.setItem('code', code);
    if (getURLParameter('expiry')) sessionStorage.setItem('expiry', expiryDate);

    // Befüllen und Anzeigen der Elemente, wenn die Parameter vorhanden sind
    let shouldShowBanner = false; // Überprüfen, ob der Banner angezeigt werden soll

    if (discount && discountElement) {
        discountElement.textContent = discount;
        discountElement.style.color = secondColor; // Farbe explizit setzen
        shouldShowBanner = true; // Banner anzeigen
    }
    if (code && codeElement) {
        codeElement.textContent = code;
        shouldShowBanner = true; // Banner anzeigen
    }
    if (expiryDate && expiryDateElement) {
        expiryDateElement.textContent = expiryDate.replace(/-/g, " "); // Bindestriche durch Leerzeichen ersetzen
        shouldShowBanner = true; // Banner anzeigen
    }

    // Farben auf die Header und Button anwenden
    if (emailHeader) {
        emailHeader.style.backgroundColor = mainColor;
        emailHeader.style.color = secondColor;
    }

    if (promoButton) {
        promoButton.style.backgroundColor = secondColor;
        promoButton.style.color = mainColor;
    }

    // Überprüfen, ob der Banner angezeigt werden soll
    if (shouldShowBanner) {
        emailHeader.classList.remove("promotion-hidden");
    }
});
